class Store {
	constructor() {
		if (!Store._instance) {
			this._data = [];
			Store._instance = this;
		}

		return Store._instance;
	}

	add(item) {
		this._data.push(item);
	}

	get(id) {
		return this._data.find(function (d) {
			return d.id === id;
		});
	}

	getAll() {
		return this._data;
	}

	update(id, item) {
		this._data = this._data.map(function (data_item) {
			if (data_item.id === id) {
				data_item = _extends(data_item, item);
			}
			return data_item;
		});
		return this.get(id);
	}
}

var instance = new Store();
Object.seal(instance);

export default instance;
